var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.666,
    y: 46,
    width: 16,
    height: 26,
    fill: "#E3EDC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35225 71.3097C1.70255 71.3097 1.17578 71.8365 1.17578 72.4862C1.17578 73.1359 1.70255 73.6627 2.35225 73.6627C27.368 73.6627 52.5234 73.6627 77.6464 73.6627C78.2961 73.6627 78.8228 73.1359 78.8228 72.4862C78.8228 71.8365 78.2961 71.3097 77.6464 71.3097H74.8907V23.1124H77.6464C78.2961 23.1124 78.8228 22.5856 78.8228 21.9359C78.8228 21.2862 78.2961 20.7594 77.6464 20.7594C77.5345 20.7594 67.0767 20.7594 66.5882 20.7594V8.69083H69.3795C70.0292 8.69083 70.5559 8.16406 70.5559 7.51436C70.5559 6.86466 70.0292 6.33789 69.3795 6.33789C52.0796 6.33789 40.0174 6.33789 10.6191 6.33789C9.96944 6.33789 9.44267 6.86466 9.44267 7.51436C9.44267 8.16406 9.96944 8.69083 10.6191 8.69083H13.4098V20.7594C13.1042 20.7594 2.83903 20.7594 2.35225 20.7594C1.70255 20.7594 1.17578 21.2862 1.17578 21.9359C1.17578 22.5856 1.70255 23.1124 2.35225 23.1124H5.10788V71.3097H2.35225ZM38.8205 71.3057H32.9382V46.9531H38.8205V71.3057ZM47.0558 71.3057H41.1735V46.9531H47.0558V71.3057ZM15.7628 8.69083H64.2353V20.7594H15.7628V8.69083ZM7.46082 23.1124C20.1548 23.1124 59.8221 23.1124 72.5378 23.1124V71.3097H49.4088V45.7767C49.4088 45.1269 48.882 44.6002 48.2323 44.6002H31.7617C31.112 44.6002 30.5852 45.1269 30.5852 45.7767V71.3097H7.46082V23.1124Z",
    fill: "#274642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0056 30V31.2691H28.796V38H27.1983V31.2691H25V30H31.0056Z",
    fill: "#587E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.055 38L34.1854 34.8839H33.4828V38H31.8851V30H34.9332C35.8624 30 36.5687 30.2266 37.0522 30.6799C37.5432 31.1331 37.7887 31.7299 37.7887 32.4703C37.7887 33.0746 37.6188 33.5807 37.2788 33.9887C36.9464 34.3966 36.463 34.6686 35.8284 34.8045L37.8227 38H36.055ZM33.4828 33.7847H34.7973C35.7113 33.7847 36.1684 33.3805 36.1684 32.5722C36.1684 32.187 36.055 31.8886 35.8284 31.6771C35.6093 31.458 35.2656 31.3484 34.7973 31.3484H33.4828V33.7847Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4653 30V38H38.8676V30H40.4653Z",
    fill: "#587E85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7831 36.3909H43.5764L43.0098 38H41.3214L44.2676 30.0907H46.0919L49.0268 38H47.3384L46.7831 36.3909ZM46.3526 35.1785L45.1741 31.8017L43.9956 35.1785H46.3526Z",
    fill: "#587E85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4868 36.7762H54.1723V38H49.8891V30H51.4868V36.7762Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.1881a4f71a6342adef58125704ae0a12.svg";
export { ForwardRef as ReactComponent };